module.exports = __webpack_public_path__ + "img/1970East-042_WEB-min.d3edf987.jpg";